export default __webpack_public_path__ + "static/media/handbook.49f59e22.txt";